import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  () => ({
    image: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      flexWrap: 'wrap',
      height: 'auto',
      position: 'relative',
      minHeight: '1px',
      minWidth: '1px',

      '&.is-cover, &.is-contain': {
        height: '100%',
        width: '100%',

        '& img': {
          height: '100%',
          width: '100%',
        },
      },

      '&.is-cover': {
        '& img': {
          objectFit: 'cover',
        },
      },

      '&.is-contain': {
        '& img': {
          objectFit: 'contain',
        },
      },

      '&.is-rounded-corners > img': {
        borderRadius: '4px',
      },

      '&:not(.is-background)': {
        display: 'block',

        '&.has-dimensions': {
          '& img': {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
          },
        },
      },

      '&.is-full-width': {
        width: '100%',

        '& img': {
          width: '100%',
        },
      },

      '& img': {
        maxWidth: '100%',
        width: 'auto',
        display: 'block',

        '&.is-rounded-corners': {
          borderRadius: '4px',
        },

        '&.no-preloader': {
          transition: 'opacity 250ms ease-in-out',
          opacity: 1,

          '&:not(.loaded)': {
            opacity: 0,
          },
        },
      },
    },
    svgArea: {
      width: '100%',
      fill: 'transparent',
      display: 'table',
    },
    preloader: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 1,
      transition: 'all 250ms ease-in-out',
      position: 'absolute',
      zIndex: 1,
      width: '100%',
      height: '100%',

      '&:not(.is-loading)': {
        opacity: 0,
      },
    },
  }),
  { name: 'GenImage' },
);

export default useStyles;
